import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=23d2ade4&scoped=true&"
import script from "./Progress.vue?vue&type=script&lang=ts&"
export * from "./Progress.vue?vue&type=script&lang=ts&"
import style0 from "./Progress.vue?vue&type=style&index=0&id=23d2ade4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2ade4",
  null
  
)

export default component.exports